"use strict";
/* Copyright (c) 2023 Xperi. All Rights Reserved.  */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceApiLogs = void 0;
/* tslint:disable:no-console */
var EventQueue_1 = require("./eventqueue/EventQueue");
var Payload_1 = require("./sendables/Payload");
var ServiceApiLogs = /** @class */ (function () {
    function ServiceApiLogs() {
    }
    ServiceApiLogs.getLogPrefix = function () {
        var d = new Date();
        var sDate = "".concat(d.getUTCDate()).padStart(2, '0');
        var sMonth = "".concat(d.getUTCMonth() + 1).padStart(2, '0');
        var sHour = "".concat(d.getUTCHours()).padStart(2, '0');
        var sMin = "".concat(d.getUTCMinutes()).padStart(2, '0');
        var sSec = "".concat(d.getUTCSeconds()).padStart(2, '0');
        var sMili = "".concat(d.getUTCMilliseconds()).padStart(3, '0');
        return "".concat(d.getFullYear(), "-").concat(sMonth, "-").concat(sDate, " ").concat(sHour, ":").concat(sMin, ":").concat(sSec, ".").concat(sMili);
    };
    ServiceApiLogs.noConsole = function () {
        ServiceApiLogs.noConsoleLog = true;
    };
    ServiceApiLogs.addEventToQueue = function (tag, resMessage) {
        var payloadMessage = "".concat(ServiceApiLogs.getLogPrefix(), " [").concat(tag, "] ").concat(resMessage);
        if (!ServiceApiLogs.noConsoleLog) {
            console.log(payloadMessage);
        }
        var payload = new Payload_1.Payload();
        payload.add('message', payloadMessage);
        ServiceApiLogs.eventQueue.add(payload);
        if (ServiceApiLogs.isDiagnosticLoggingInitialized) {
            ServiceApiLogs.upload(ServiceApiLogs.transport);
        }
    };
    ServiceApiLogs.upload = function (transport) {
        ServiceApiLogs.isDiagnosticLoggingInitialized = true;
        ServiceApiLogs.transport = transport;
        if (ServiceApiLogs.eventQueue.hasNext()) {
            transport
                .send(ServiceApiLogs.eventQueue.next().merge(ServiceApiLogs.globals))
                .then(function () {
                ServiceApiLogs.eventQueue.remove();
            })
                .catch(function (err) {
                if (err) {
                    ServiceApiLogs.eventQueue.remove();
                }
            })
                .finally(function () {
                ServiceApiLogs.upload(transport);
            });
        }
    };
    ServiceApiLogs.setEventQueueSize = function (size) {
        ServiceApiLogs.eventQueue.setSize(size);
    };
    ServiceApiLogs.setGlobals = function (params) {
        ServiceApiLogs.globals = params;
    };
    ServiceApiLogs.isDiagnosticLoggingInitialized = false;
    ServiceApiLogs.eventQueue = new EventQueue_1.EventQueue();
    ServiceApiLogs.noConsoleLog = false;
    ServiceApiLogs.globals = new Payload_1.Payload();
    return ServiceApiLogs;
}());
exports.ServiceApiLogs = ServiceApiLogs;
